import { render, staticRenderFns } from "./previewImg.vue?vue&type=template&id=9afa395a"
import script from "./previewImg.vue?vue&type=script&lang=js"
export * from "./previewImg.vue?vue&type=script&lang=js"
import style0 from "./previewImg.vue?vue&type=style&index=0&id=9afa395a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports